/**
 * Date-extensions locale Klingon [tlh]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tlh', {
    monthNames: ['Tera’ jar wa’','Tera’ jar cha’','Tera’ jar wej','Tera’ jar loS','Tera’ jar vagh','Tera’ jar jav','Tera’ jar Soch','Tera’ jar chorgh','Tera’ jar Hut','Tera’ jar wa’maH','Tera’ jar wa’maH wa’','Tera’ jar wa’maH cha’'],
    monthShortNames: ['Jar wa’','Jar cha’','Jar wej','Jar loS','Jar vagh','Jar jav','Jar Soch','Jar chorgh','Jar Hut','Jar wa’maH','Jar wa’maH wa’','Jar wa’maH cha’'],
    dayNames: ['LojmItjaj','DaSjaj','Povjaj','GhItlhjaj','Loghjaj','Buqjaj','GhInjaj'],
    dayShortNames: ['LojmItjaj','DaSjaj','Povjaj','GhItlhjaj','Loghjaj','Buqjaj','GhInjaj']
});
